module.exports = __webpack_public_path__ + "51636defa8bbb3e275bb37d6883a0850.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-28.png
// module id = 2201
// module chunks = 0